import config from '../../config';
import { request } from '../../libraries/request'

const getSession = (params = {}, token) => {
  console.log('SERVICES::VIDEO::get', params, token);

  return request({
    url: config.BASE_API_URL + config.API.VIDEO_SESSION,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      //response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const getSessionAndToken = (params = {}, token) => {
  console.log('SERVICES::VIDEO::get', params, token);

  return request({
    url: config.BASE_API_URL + config.API.VIDEO_SESSION_TOKEN,
    accessToken: token,
    data: params,
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {
      //response.data.query.page_size = config.QUERIES_PAGE_SIZE;
    }
    return response;
  })
}

const getToken = (sessionid, token) => {
  console.log('SERVICES::PRESCRIPTIONS::get', sessionid, token);
  return request({
    url: config.BASE_API_URL + config.API.VIDEO_TOKEN.replace('{sessionid}', sessionid),
    accessToken: token,
    // data: {},
  })
  .then(response => {
    console.log('RETURN FROM API', response);
    if (response.success) {

    }
    return response;
  })

}
export default {
  getSession,
  getSessionAndToken,
  getToken,
};
